<template>
  <div class="box-wrap active-box-wrap" :style="boxWrapStyleObj">
    <span class="border-left-top"></span>
    <span class="border-left-bottom"></span>
    <span class="border-right-top"></span>
    <span class="border-right-bottom"></span>
    <div
      class="statis-title bg1"
      style="display: flex; justify-content: center"
      :ref="`${activeType}_statisTitle`"
    >
      <span>{{ title }}</span
      ><span class="split-line">|</span>
      <div class="active-statis">
        <Select
          v-model="timeSolt"
          ref="timeIntervalSelectRef"
          placeholder="全部时段"
          @on-change="changeTimeSolt"
        >
          <!-- <Option value="0">全部时段</Option> -->
          <Option value="3">本学年</Option>
          <Option value="1">近一周</Option>
          <Option value="2">近一月</Option>
        </Select>
      </div>
      <span class="active-box-more-txt click-element" @click="lookMoreData" v-if="channel!='sy'">
        更多
        <i></i>
      </span>
    </div>
    <ul class="active-static-tab" :ref="`${activeType}_staticTabRef`">
      <template v-for="item in tabList">
        <li
          class="active-static-tab-item click-element"
          :class="item.code == tabCode ? 'active-static-tab-item-selected' : ''"
          @click="changeModule(item.code)"
          :title="item.title"
        >
          {{ item.title }}
        </li>
      </template>
    </ul>
    <div class="active-static-tab-content" :style="contentStyleObj">
      <active-content
        :activeType="activeType"
        ref="activeTypeRef"
        :rankingList="activeGradeList"
        :tabCode="tabCode"
      ></active-content>
    </div>
  </div>
</template>

<script>
import {
  findSchoolYears,
  findHomeworkActiveGrade,
  findMicroActiveGrade,
  findResourceActiveGrade,
  findLearningActiveGrade,
  findInteractActiveGrade,
} from "../../../service/bigDataApi.js";
import CountUp from "../../../components/countUp.vue";
import activeContent from "./activeContent.vue";

export default {
  name: "active-grade-statics",
  data() {
    return {
      screenWidth: 0, //屏幕宽度
      boxWrapStyleObj: {
        height: "",
      },
      contentStyleObj: {
        height: "",
      },
      styleObj: {
        width: "100%",
        height: "100%",
      },
      countWeight: 400,
      tabList: [
        {
          code: "resTab",
          title: "分享课件数",
        },
        {
          code: "microTab",
          title: "分享微课数",
        },
        {
          code: "hwTab",
          title: "布置作业数",
        },
        {
          code: "studyTab",
          title: "探究学习",
        },
        {
          code: "interTab",
          title: "互动答疑",
        },
      ],
      timeSolt: "3",
      startDate: "",
      endDate: "",
      tabCode: "resTab",
      activeGradeList: [],
      activeClassList: [],
      activeTeacherList: [],
      curActiveGradeData: {}, //当前年级活跃下的统计数据
      gradeList: [],
      subjectList: [],
      gradeId: "",
      subjectId: "",
      title: "年级活跃情况",
      activeType: "grade",
      channel: process.env.VUE_APP_CHANNEL,
    };
  },
  components: {
    CountUp,
    activeContent,
  },
  props: {
    screenHeight: Number,
    titleHeight: Number,
    schoolId: String,
    schoolName: String,
    schoolCode: String,
  },
  watch: {
    screenHeight: "initBoxHeight",
    titleHeight: "initBoxHeight",
  },
  methods: {
    /**
     * 初始化box高度
     */
    initBoxHeight() {
      let titleRef = this.activeType + "_statisTitle";
      let tabRef = this.activeType + "_staticTabRef";
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }
      let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
      let contentHeight =
        boxWrapHeight -
        this.$refs[titleRef].offsetHeight -
        this.$refs[tabRef].offsetHeight -
        20;
      this.boxWrapStyleObj.height = boxWrapHeight + "px";
      this.contentStyleObj.height = contentHeight + "px";
    },
    /**
     * 获取年级下作业的活跃统计情况
     */
    async getHomeworkActiveGrade() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
        pageno: 1,
        pagesize: 10,
        top: 5, //取前五
      };
      if (this.startDate != "" && this.endDate != "") {
        param.startdate = this.startDate;
        param.enddate = this.endDate;
      }
      await findHomeworkActiveGrade(param)
        .then(function (data) {
          _this.activeGradeList = [];
          if (Object.keys(data.rows).length > 0) {
            _this.activeGradeList = data.rows;
            //遍历集合 计算作业提交率和作业批改率
            let calcData = _this.calcHomeworkData(data.rows);
            _this.activeGradeList = calcData;
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取年级下微课的活跃统计情况
     */
    async getMicroActiveGrade() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
        pageno: 1,
        pagesize: 10,
        top: 5, //取前五
      };
      if (this.startDate != "" && this.endDate != "") {
        param.startdate = this.startDate;
        param.enddate = this.endDate;
      }
      await findMicroActiveGrade(param)
        .then(function (data) {
          _this.activeGradeList = [];
          if (Object.keys(data.rows).length > 0) {
            _this.activeGradeList = data.rows;
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取年级下资源的活跃统计情况
     */
    async getResourceActiveGrade() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
        pageno: 1,
        pagesize: 10,
        top: 5, //取前五
      };
      if (this.startDate != "" && this.endDate != "") {
        param.startdate = this.startDate;
        param.enddate = this.endDate;
      }
      await findResourceActiveGrade(param)
        .then(function (data) {
          _this.activeGradeList = [];
          // _this.activeGradeList = [{
          //     "grade_id": "8",
          //     "understand_rate": 0.91,
          //     "res_num": 675,
          //     "read_rate": 0.61,
          //     "grade_name": "八年级"
          // }, {
          //     "grade_id": "7",
          //     "understand_rate": 0.88,
          //     "res_num": 128,
          //     "read_rate": 0.3,
          //     "grade_name": "七年级"
          // }, {"grade_id": "9", "understand_rate": 0.99, "res_num": 56, "read_rate": 0.18, "grade_name": "九年级"}];
          if (Object.keys(data.rows).length > 0) {
            _this.activeGradeList = data.rows;
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取年级下探究学习的活跃统计情况
     */
    async getLearningActiveGrade() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
        pageno: 1,
        pagesize: 10,
        top: 5, //取前五
      };
      if (this.startDate != "" && this.endDate != "") {
        param.startdate = this.startDate;
        param.enddate = this.endDate;
      }
      await findLearningActiveGrade(param)
        .then(function (data) {
          _this.activeGradeList = [];
          if (Object.keys(data.rows).length > 0) {
            _this.activeGradeList = data.rows;
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 获取年级下互动答疑的活跃统计情况
     */
    async getInteractActiveGrade() {
      let _this = this;
      let param = {
        schoolid: this.schoolId,
        pageno: 1,
        pagesize: 10,
        top: 5, //取前五
      };
      if (this.startDate != "" && this.endDate != "") {
        param.startdate = this.startDate;
        param.enddate = this.endDate;
      }
      await findInteractActiveGrade(param)
        .then(function (data) {
          _this.activeGradeList = [];
          if (Object.keys(data.rows).length > 0) {
            _this.activeGradeList = data.rows;
          }
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 计算各年级的作业提交率和作业批改率
     */
    calcHomeworkData(data) {
      for (let i = 0; i < data.length; i++) {
        data[i].hwSubmitRate = this.$utils.toDecimal(
          (data[i].hw_submit_num / data[i].stu_num) * 100
        );
        data[i].hwCorrectRate = this.$utils.toDecimal(
          (data[i].hw_correct_num / data[i].hw_submit_num) * 100
        );
      }
      this.curActiveGradeData = data[0];

      return data;
    },
    /**
     * 选中当前排行榜已选中项
     */
    changeGrade(index) {
      this.curActiveGradeData = this.activeGradeList[index];
    },
    /**
     * 选择时间段
     */
    async changeTimeSolt() {
      let todayStr = this.$utils.getNDayStr(1)
;
      this.endDate = todayStr + " 23:59:59";
      //获取近一周时间
      if (this.timeSolt === "1") {
        this.startDate = this.$utils.getYestodaySevenDayStr(1) + " 00:00:00";
      } else if (this.timeSolt === "2") {
        //获取近一月时间
        this.startDate = this.$utils.getPreMonthDay(todayStr, 1) + " 00:00:00";
      } else if (this.timeSolt === "3") {
        //获取本学年时间（按学校真实学年起止时间）
        const res = await findSchoolYears({ schoolid: this.schoolId });
        if (res && res.length > 0) {
          this.startDate = res[0].startTime + " 00:00:00";
          this.endDate = res[0].endTime + " 23:59:59";
        }
      } else {
        this.startDate = "";
        this.endDate = "";
      }
      this.handleSearch();
    },
    judgeSchoolYear() {
      let currentDate = new Date().getTime();
      let currentSchoolYear = new Date(
        new Date().getFullYear() + "-08-10 00:00:00"
      ).getTime();
      if (currentDate < currentSchoolYear) {
        return new Date().getFullYear() - 1;
      } else {
        return new Date().getFullYear();
      }
    },
    /**
     * 根据type和当前tab获取相应数据
     */
    changeModule(val) {
      this.tabCode = val;
      this.changeTimeSolt();
      // this.$refs.timeIntervalSelectRef.clearSingleSelect();
      this.handleSearch();
    },
    /**
     * 根据不同的情况请求数据
     */
    handleSearch() {
      switch (this.tabCode) {
        case "hwTab":
          this.getHomeworkActiveGrade();
          break;
        case "microTab":
          this.getMicroActiveGrade();
          break;
        case "resTab":
          this.getResourceActiveGrade();
          break;
        case "studyTab":
          this.getLearningActiveGrade();
          break;
        case "interTab":
          this.getInteractActiveGrade();
          break;
        default:
          this.getHomeworkActiveGrade();
          break;
      }
    },
    // /**
    //  * 更新当前选中的学科id或年级id
    //  */
    // updateSelectedData (name, id) {
    //     this[name] = id;
    //     this.handleSearch()
    // }
    /**
     * 查看更多数据信息
     */
    lookMoreData() {
      let routeData = this.$router.resolve({
        name: "actstatisdetails",
        query: {
          schoolId: this.schoolId,
          schoolName: this.schoolName,
          schoolCode: this.schoolCode,
          activeType: this.activeType,
          tabCode: this.tabCode,
          activeTypeName: "年级活跃情况",
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
  mounted() {
    this.changeModule("resTab");
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";
@import "../../../style/layout";

.bg1 {
  background-image: url("../../../assets/images/databoard/title-bg3.png");
}

.active-static-tab-item {
  background-image: url("../../../assets/images/databoard/icon_tab_normal.png");
}

.active-static-tab-item-selected {
  background-image: url("../../../assets/images/databoard/icon_tab_hover.png");
}

.active-box-more-txt i {
  background-image: url(../../../assets/images/databoard/active-icon.png);
  background-position: -299px 90px;
}

.active-static-icon-arrow-down {
  background-image: url(../../../assets/images/databoard/active-icon.png);
  background-position: -224px 90px;
}
</style>

<style lang="scss">
.active-statis {
  .ivu-select-selection {
    box-shadow: transparent !important;
    background-color: transparent !important;
    border: transparent !important;
  }
  .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    font-size: 16px !important;
    color: #0efcff !important;
    padding-left: 0 !important;
  }
  .ivu-select-arrow {
    color: #0efcff !important;
  }

  .ivu-select-dropdown {
    max-height: 100px;
    background: rgba(10, 18, 39, 0.97);
    box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;
    border-radius: 5px;
  }
  .ivu-select-item {
    color: #0efcff !important;
    text-align: center;
  }

  .ivu-select-item:hover {
    background: #0efcff !important;
    color: #0a1227 !important;
  }

  .ivu-select-item-focus {
    background: #0efcff !important;
    color: #0a1227 !important;
  }
}
</style>
